/**
 * Serialize a POJO for use in
 * application/x-www-form-urlencoded calls.
 *
 * @param  {Object} obj The object to serialize
 * @return {String}     The serialized response
 */
export default obj => {
  if (!obj) {
    return '';
  }

  const s = [];

  Object.keys(obj).forEach(key => {
    if (obj[key] && obj[key].constructor === Array) {
      obj[key].forEach(value => {
        s.push(`${key}=${encodeURIComponent(value)}`);
      });
    } else {
      s.push(`${key}=${encodeURIComponent(obj[key])}`);
    }
  });

  return s.join('&');
};
